<template>
  <v-app>
    <v-progress-linear
      :color="color"
      :active="loading"
      background-color="transparent"
      indeterminate
      fixed
      top
    ></v-progress-linear>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'app',
  data() {
    return { firstLoad: true };
  },
  watch: {
    loading() {
      if (!this.loading && this.firstLoad) {
        this.firstLoad = false;
      }
    },
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    scope() {
      return this.$route.params.scope;
    },
    color() {
      if (
        (
          this.firstLoad
          && !['index', 'track', 'search']
            .some(r => (this.$route.name || '').match(r))
        )
        || this.$route.name.includes('client.')
      ) {
        return 'primary';
      }
      return 'white';
    },
  },
  methods: {
    clear() {
      this.$store.commit('CLEAR_SEARCH');
      this.$store.commit('CLEAR_ORDER');
      this.$router.push({ name: 'business-scope.index' });
    },
  },
};
</script>
